export default "__VITE_ASSET__5Ss9FoxK__"